import { FC, ReactNode, useReducer } from "react";
import { initialStateTestRegistry, TestRegistryContext } from "./testRegistryContext";
import { registerTestReducer } from "./testRegistryReducer";

type IProps = {
  children: ReactNode;
};

const TestRegistryProvider: FC<IProps> = ({ children }) => {
  const [state, dispatchTestRegistry] = useReducer(registerTestReducer, initialStateTestRegistry);

  return <TestRegistryContext.Provider value={{ state, dispatchTestRegistry }}>{children}</TestRegistryContext.Provider>;
};

export default TestRegistryProvider;
